import React, { useReducer, useMemo, useState } from 'react'
import { Bar } from 'react-chartjs-2'
import { Form } from 'semantic-ui-react'
import { numFormat } from '@rededompedro/utils'
import request from 'services/http'
import { tap, finalize } from 'rxjs/operators'
import { useSubscription } from 'utils'

function reducer(state, action) {
    switch(action.type) {
        case 'setForm':
            return { ...state, ...action.payload }
        default:
            return state
    }
}

export default function Resumo({ operacoes, tipos, periodos, grafico, setGrafico }) {

    const [form, dispatch] = useReducer(reducer, {
        tipo: 999,
        operacao: 1
    })
    const [isSubmitting, setIsSubmitting] = useState(false)

    function handleChange(_, { name, value }) {
        dispatch({ type: 'setForm', payload: { [name]: value }})
        setIsSubmitting(true)
    }

    const fetchGraph$ = useMemo(() => request({ 
        url: '/dre/pdd/graph', 
        method: 'POST', 
        body: form 
    }).pipe( 
        tap( ({ response }) => setGrafico(response.dados)),
        finalize(() => setIsSubmitting(false))
    ), [form, setGrafico])

    useSubscription(fetchGraph$, isSubmitting)

    const line = periodos.map(x => {
        let d = grafico ? grafico.find(y => y && x.descricao === y.descricao) : null
        return d ? d.unidades : 0
    }) 

    const bar = periodos.map(x => {
        let d = grafico ? grafico.find(y => y && x.descricao === y.descricao) : null
        return d ? d.total : 0
    })

    const data = {
        labels: periodos.map(x => x.descricao),
        datasets: [
            {
                label: 'Unidades',
                type: 'line',
                fill: false,
                borderColor: '#042144de',
                backgroundColor: '#042144de',
                pointBorderColor: '#042144de',
                pointBackgroundColor: '#042144de',
                pointHoverBackgroundColor: '#042144de',
                pointHoverBorderColor: '#042144de',
                data: line,
                yAxisID: 'y-axis-2'
            },
            {
                label: 'Total',
                type: 'bar',
                fill: false,
                backgroundColor: '#f93f2ede',
                borderColor: '#f93f2ede',
                hoverBackgroundColor: '#f93f2ede',
                hoverBorderColor: '#f93f2ede',
                data: bar,
                yAxisID: 'y-axis-1'
            }
        ]
    }

    const options = {
        maintainAspectRatio: false,
        responsive: true,
        tooltips: {
            mode: 'label',
            bodyFontSize: 14,
            titleFontSize: 14,
            callbacks: {
                label: (tooltipItem, data) => {
                    if (data.datasets[tooltipItem.datasetIndex].label === 'Total')
                        return `  ${data.datasets[tooltipItem.datasetIndex].label} R$ ${numFormat(Number(tooltipItem.value))}`
                    else
                        return `  ${data.datasets[tooltipItem.datasetIndex].label} ${tooltipItem.value}`
                }
            }
        },
        elements: {
            line: {
                fill: false
            }
        },
        scales: {
            xAxes: [
                {
                    display: true,
                    gridLines: {
                        display: false
                    }
                }
            ],
            yAxes: [
                {
                    type: 'linear',
                    display: true,
                    position: 'left',
                    id: 'y-axis-1',
                    gridLines: {
                        display: false
                    },
                },
                {
                    type: 'linear',
                    display: true,
                    position: 'right',
                    id: 'y-axis-2',
                    gridLines: {
                        display: false
                    },
                }
            ]
            
        }
    }

    const config = { data, options }

    return (
        <>
            <Form size='mini' className='w-100' noValidate>
                <div className="row">
                    <div className="col">
                        <Form.Select label='Tipo' placeholder='Selecionar tipo' name='tipo' value={form.tipo} onChange={handleChange} options={tipos ? [{ text: 'Tudo', value: 999 }].concat(tipos.map(x => Object.assign({}, { text: x.descricao, value: x.tipo_entrada }))) : []}/>
                    </div>
                    <div className="col">
                        <Form.Select label='Operação' placeholder='Escolha a operação' name='operacao' value={form.operacao} onChange={handleChange} options={operacoes ? operacoes.map(x => Object.assign({}, { text: x.descricao, value: x.id })) : []} />
                    </div>
                </div>
            </Form>
            <div className="flex-grow-1 w-100">
                <Bar {...config} />
            </div>
        </>
    )
}
